import dayjs from "dayjs";
import * as Yup from "yup";

export const email = Yup.string()
  .email("Invalid email address")
  .required("Email is required");

export const password = Yup.string()
  .required("Password is required")
  .min(8, "Must be at least 8 characters")
  .matches(/[A-Z]/, "Must contain an uppercase letter")
  .matches(/[a-z]/, "Must contain a lowercase letter")
  .matches(/\d/, "Must contain a number")
  .matches(
    /[!@#$%^&*(),.?":{}|<>]/,
    "Must contain at least one special character"
  );

export const confirmPassword = Yup.string()
  .oneOf([Yup.ref("password")], "Passwords must match")
  .required("Confirm your password");

export const newPassword = Yup.string()
  .required("Password is required")
  .min(8, "Must be at least 8 characters")
  .matches(/[A-Z]/, "Must contain an uppercase letter")
  .matches(/[a-z]/, "Must contain a lowercase letter")
  .matches(/\d/, "Must contain a number")
  .matches(
    /[!@#$%^&*(),.?":{}|<>]/,
    "Must contain at least one special character"
  );

export const passwordRequired = Yup.string()
  .required("Password is required")
  .min(1, "Enter the password to continue");

// You can add more here for other forms
export const name = Yup.string()
  .required("Name is required")
  .min(2, "Name too short");

export const currentPassword = Yup.string().required("Password is required");

export const otp = Yup.string()
  .required("OTP is required")
  .matches(/^\d+$/, "OTP must be numeric")
  .length(6, "OTP must be exactly 6 digits");

export const firstname = Yup.string().required("First Name is required");
export const lastname = Yup.string().required("Last Name is required");
export const phoneNumber = Yup.string()
  .required("Phone Number is required")
  .matches(
    /^(\+1\s?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})[\s.-]?[0-9]{3}[\s.-]?[0-9]{4}$/,
    "Please enter a valid  phone number"
  )
  .test("us-format-only", "Only US phone numbers are accepted", (value) => {
    if (!value) return false;
    // Remove all non-digit characters for validation
    const cleanValue = value.replace(/\D/g, "");

    // Must start with 1 (country code) or be 10 digits without country code
    if (cleanValue?.startsWith("1")) {
      return cleanValue.length === 11; // +1 followed by 10 digits
    } else {
      return cleanValue.length === 10; // Just the 10-digit number
    }
  });

export const counselorName = Yup.string().required(
  "Counselor Name is required"
);

export const studentId = Yup.string().required("Student ID is required");

export const fosterId = Yup.string().required("Foster ID is required");

export const file = Yup.mixed().required("File is required");

export const users = Yup.array().min(1, "Please select at least one user");

export const role = Yup.string().required("Role is required");
export const address = Yup.string().required("Address is required");

export const phone = Yup.string()
  .required("Phone Number is required")
  .matches(
    /^(\+1\s?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})[\s.-]?[0-9]{3}[\s.-]?[0-9]{4}$/,
    "Enter a valid US phone number"
  );

export const school = Yup.string().required("School is required");

export const emergencyContactName = Yup.string()
  .required("Contact name is required")
  .min(2, "Too short");

export const caregiverName = Yup.string()
  .required("Caregiver name is required")
  .min(2, "Too short");

export const zipCode = Yup.string()
  .nullable()
  .matches(/^\d{5}(-\d{4})?$/, "Enter a valid ZIP code")
  .notRequired();

export const dateOfBirth = Yup.string()
  .nullable()
  .test("format", "Date must be in MM/DD/YYYY format", (value) => {
    // ✅ skip validation if empty
    if (!value || value.trim() === "") return true;

    // must match format like 12/31/2024
    return /^\d{2}\/\d{2}\/\d{4}$/.test(value);
  })
  .test("valid-date", "Invalid date (please check day or month)", (value) => {
    if (!value || value.trim() === "") return true; // skip if empty
    const parsed = dayjs(value, "MM/DD/YYYY", true);
    return parsed.isValid(); // reject if invalid date like 33 or 13
  })
  .test("not-in-future", "Date of Birth cannot be in the future", (value) => {
    if (!value || value.trim() === "") return true; // skip if empty
    const parsed = dayjs(value, "MM/DD/YYYY", true);
    return parsed.isValid() && parsed.isBefore(dayjs(), "day");
  });

export const safeText = Yup.string()
  .required("This field is required")
  .test(
    "exact-match",
    'Please type "I am safe right now", "I am safe now", or "I am safe".',
    (value) => {
      if (!value) return false;
      const normalized = value.toLowerCase().replace(/\s+/g, " ").trim();
      return ["i am safe right now", "i am safe now", "i am safe"].includes(
        normalized,
      );
    },
  );
